export default "__VITE_ASSET__0DQXWYRk__"